export default function ContactUsMapArea({ company }) {
    return (
        <div className="map-area mb-60">
            <iframe
                src={`https://maps.google.com/maps?q=${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                width="100%"
                height="480"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"></iframe>
        </div>
    )
}